import React, { useMemo } from "react";
import Select from "react-select";
import countryList from "react-select-country-list";

const CountrySelector = ({
  label,
  name,
  value,
  // options,
  compulsory = false,
  formField = true,
  error,
  ...props
}) => {
  // 2. Use useMemo to load and cache the country options list so it doesn't recalculate on every render
  const options = useMemo(() => countryList().getData(), []);

  return (
    <div className={`form-group ${formField ? "mt-3" : ""}`}>
      <label htmlFor={name} className="label">
        {label || "Country:"}
      </label>
      <div className={`flex ${props.isDisabled ? "" : "pb-3"}`}>
        <Select
          className={`${
            formField ? "myreact-select-2 container-select" : "myreact-select"
          }`}
          inputId={name}
          name={name}
          value={value}
          options={options}
          {...props}
          isSearchable={true} // Enables typing to search the list
        />
        {compulsory && <span className="label-imp-select-prd">*</span>}
      </div>
      {error && formField ? (
        <p className="label-error">{error}</p>
      ) : (
        error && <p className="label-error-pos">{error}</p>
      )}
    </div>
  );
};

export default CountrySelector;
